import { formatSalesgroupsSelectExtendedList } from '.';
import { Salesgroup } from 'src/types';

export const formatAllSalesgroups = (carlines: Salesgroup[]) =>
carlines.map((carline) => formatSalesgroupsSelectExtendedList(carline)).filter((c) => c !== null);
